<template>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; justify-content: space-between">
      <cargo-input v-model="job.shipperCode" style="width:115px;margin-right: 5px;flex-grow: 1;" :placeholder="disabled ? '' : $t('SeaExport.ShipperId')" :auto-uppercase="autoUppercase" :disabled="disabled" @change="onChange('shipperCode')" />
      <cargo-company-select
        :disabled="disabled"
        :method-params="{shipper:true,active:true}"
        :default-value="job.shipperId||''"
        style="display: inline-block;width:145px;flex-grow: 1;"
        @change="shipperChange"
      />
    </div>
    <cargo-input
      v-for="i in 7"
      :key="i"
      v-model="job['shipperLine'+i]"
      :use-read-only="true"
      :disabled="disabled"
      :auto-uppercase="autoUppercase"
      style="margin-top: 5px"
      @change="onChange('shipperLine'+i)"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'AeBasicShipper',
  components: { cargoInput, cargoCompanySelect },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    autoUppercase: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    },
    async shipperChange(data) {
      const form = this.job
      form.shipperId = data.value
      if (form.shipperId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.shipperLine1 = manifestAddress.addressLine1
          form.shipperLine2 = manifestAddress.addressLine2
          form.shipperLine3 = manifestAddress.addressLine3
          form.shipperLine4 = manifestAddress.addressLine4
          form.shipperLine5 = manifestAddress.addressLine5
          form.shipperLine6 = manifestAddress.addressLine6
          form.shipperLine7 = manifestAddress.addressLine7
        } else {
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
      }
      const items = []
      items.push({ key: 'shipperId', value: form.shipperId })
      for (let i = 1; i <= 7; i++) {
        items.push({ key: `shipperLine${i}`, value: form[`shipperLine${i}`] })
      }
      this.$emit('childrenChange', items)
    }
  }
}
</script>
